<div>

  <app-header title="Carriers" [progressvalue]="66" routeName="group"></app-header>
  <div class="wb-coverage-wrapper wb-full-height">
    <section class="wb-coverage-content">
      <div class="controls toggle full-width">

        <mat-chip-list class="mat-chip-list-stacked" aria-orientation="vertical">
          <mat-chip class="mat-chip-coverage-medical-carrier"
            *ngFor="let carrier of carriers?.AvailableActiveCarriers; let i = index"
            [selected]="selectedCarrier.CarrierId == carrier.CarrierId" (click)="selectCarrier(carrier)">
            <span class="coverage-screen-carrier-name"
              [attr.data-qaauto]="carrier.CarrierName">{{carrier.CarrierName}}</span>
          </mat-chip>


        </mat-chip-list>
      </div>

    </section>
  </div>
</div>

<footer class="wb-coverage-footer">
  <div class="max-size-wrapper">
    <button class="wb-button mdl-button mdl-js-button" [disabled]="!isCarrierSelect" (click)=saveCarrierInfo()>
      Next
    </button>
  </div>
</footer>